import InquiriesFilter from './InquiriesFilter';

const Inquiries = {
  Filter: InquiriesFilter
};

export default Inquiries;
